import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { TipoLancamentoOpcao } from '../../regra-conciliacao-automatica/models/tipo-lancamento-opcao';
import { ContaCaixaConfiguracao } from '../models/conta-caixa-configuracao';
import { TipoLancamentoConfiguracao } from '../models/tipo-lancamento-configuracao';
import { ContaBancoVincularAoCaixaManual } from '../models/conta-banco-vincular-ao-caixa-manual';
import { MesclarContasRetorno } from '../models/mesclar-contas-retorno';
import { MesclarTiposRetorno } from '../models/mesclar-tipos-retorno';
import { AlterarContaTipoRetorno } from '../models/alterar-conta-tipo-retorno';
import { MesclarTiposEmMassa } from '../models/mesclar-tipos-em-massa';
import { AlterarContaTiposEmMassa } from '../models/alterar-conta-tipos-em-massa';
import { TravaContaCaixa } from '../models/trava-conta-caixa';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoCaixaApiService extends ApiService {

  baseUrlRoute: string = "configuracao-caixa";

  constructor(
    public override http: HttpClient
  ) {
    super(http);
  }

  public getContasCaixa(): Observable<ContaCaixaConfiguracao[]> {
    return this.get<ContaCaixaConfiguracao[]>(`/${this.baseUrlRoute}`);
  }

  public getTiposDaConta(contaCaixaId: number): Observable<TipoLancamentoOpcao[]> {
    return this.get<TipoLancamentoOpcao[]>(`/conta-caixa/${contaCaixaId}/tipos`);
  }

  public saveCriarContaCaixa(nomeConta: string): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/criar-conta-caixa`, null, { nome: nomeConta });
  }

  public saveCriarTipoLancamento(contaId: number, nomeTipo: string): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/conta/${contaId}/criar-tipo-lancamento`, null, { nome: nomeTipo });
  }

  public importarContasCaixa(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('formFile', file, file.name);

    return this.post<void>(`/lancamento-caixa-excel/importar-lancamentos`, null, formData);
  }

  public saveAlterarNomeContaCaixa(conta: ContaCaixaConfiguracao): Observable<void> {
    return this.put<void>(`/${this.baseUrlRoute}/alterar-nome-conta`, null, conta);
  }

  public saveAlterarNomeTipoLancamento(tipo: TipoLancamentoConfiguracao): Observable<void> {
    return this.put<void>(`/${this.baseUrlRoute}/alterar-nome-tipo`, null, tipo);
  }

  public vincularContaBancoAContaCaixa(contaBanco: ContaBancoVincularAoCaixaManual): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/vincular-conta-banco-a-conta-caixa`, null, contaBanco);
  }

  public mesclarContasCaixa(retorno: MesclarContasRetorno): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/mesclar-contas`, null, retorno);
  }

  public mesclarTipos(retorno: MesclarTiposRetorno): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/mesclar-tipos`, null, retorno);
  }

  public alterarContaTipo(retorno: AlterarContaTipoRetorno): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/alterar-conta-tipo`, null, retorno);
  }

  public mesclarTiposEmMassa(retorno: MesclarTiposEmMassa): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/mesclar-tipos-em-massa`, null, retorno);
  }

  public alterarContaTiposEmMassa(retorno: AlterarContaTiposEmMassa): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/alterar-conta-tipos-em-massa`, null, retorno);
  }

  public arquivarContaCaixa(contaId: number): Observable<void> {
    return this.patch<void>(`/conta-caixa/${contaId}/arquivar`);
  }

  public getContasArquivadas(): Observable<ContaCaixaConfiguracao[]> {
    return this.get<ContaCaixaConfiguracao[]>(`/${this.baseUrlRoute}/arquivadas`);
  }

  public desarquivarContaCaixa(contaId: number): Observable<void> {
    return this.patch<void>(`/conta-caixa/${contaId}/desarquivar`);
  }

  public getTrava(contaCaixaId: number): Observable<TravaContaCaixa | null> {
    return this.get<TravaContaCaixa | null>(`/trava-conta-caixa/${contaCaixaId}`);
  }

  public setOrUpdateTrava(contaCaixaId: number, dataTrava: Date): Observable<void> {
    return this.put<void>(`/trava-conta-caixa`, null, { contaCaixaId, dataTrava });
  }

  public removerTrava(contaCaixaId: number): Observable<void> {
    return this.delete<void>(`/trava-conta-caixa/${contaCaixaId}`);
  }
}
